import React, { useState, useRef, useMemo, useEffect, useCallback } from 'react';
import JoditEditor from 'jodit-react';
import './JoditEditor.css'
import { debounce } from 'lodash';
import { e } from 'mathjs';

const JoditTextEditor = (props) => {
	const { preValues, isDraftAlready, contentShowFlag, composeMailToShow, setEmailContent, id, commentContent, joditClass } = props;
	const editor = useRef(null);
	const [content, setContent] = useState('');
const [showSuggestions, setShowSuggestions] = useState(false);
const [mention, setMention] = useState("");
	useEffect(e => {
		if (commentContent != undefined) {
			setContent(commentContent)
		}
	}, [commentContent])
	useEffect(e => {
		if (id == "email") {
			setEmailContent(content)
		} else if (id == "transition") {
			setEmailContent(content)
		}
	}, [content])


	let forwardContent = id == "email" ? `
    <hr><pre class='forward-content'}>
      ============ Forwarded message ============
      From: ${composeMailToShow?.from}
      To: ${(composeMailToShow?.to)?.map((item) => item.email).join("; ")}
      ${composeMailToShow?.cc?.length > 0 ? `Cc: ${(composeMailToShow?.cc)?.map((item) => item.email).join("; ")}` : ""}
      ${composeMailToShow?.bcc?.length > 0 ? `Bcc: ${(composeMailToShow?.bcc)?.map((item) => item.email).join("; ")}` : ""}
      Subject: ${composeMailToShow?.subject}
      ============ Forwarded message ============</pre>
  `
		.trim()
		.split("\n")
		.filter(line => line.trim().length > 0)
		.join("\n") : "";

	useEffect(() => {
		if (id == "email") {
			let sign;
			if (contentShowFlag == "forward") {
				sign = "<br><br>" + props.signature + forwardContent + preValues;
			} else {
				sign = props.signature
			}
			let signatureWithBreaks;
			if (!isDraftAlready) {
				if (preValues) {
					if (contentShowFlag == "forward") {
						signatureWithBreaks = `${sign}`;
					} else {
						signatureWithBreaks = `${preValues}<br><br>${sign}`;
					}
				} else {
					signatureWithBreaks = `<br><br>${sign}`;
				}

				// const newContent = RichTextEditor.createValueFromString(signatureWithBreaks, 'html');
				if(props?.signature!=="NoSignature"){
					setContent(signatureWithBreaks);
				} 
			} else {
				if (preValues) {
					signatureWithBreaks = `${preValues}`;
				} else {
					signatureWithBreaks = `<br><br>${sign}`;
				}
				if(props?.signature!=="NoSignature"){
					setContent(signatureWithBreaks);
				} 
			}
		}
		// Set the signature text upon component mount
	}, [props?.signature, preValues]);
	const messageBehaviorRef = useRef(props.messageBehavior);
	useEffect(() => { 
		messageBehaviorRef.current = props.taskCommenRef == undefined ? props.messageBehavior : props.taskCommenRef;
	}, [props.messageBehavior,props.taskCommenRef]);
	const config = useMemo(() => ({
		toolbar: true,
		placeholder:'',
		minHeight: 60,
		maxHeight: 150,
		toolbarSticky: false,
		enter: 'p', // 👈 Add this line here for after enter go to next line 
		events: {
			afterInit: (instance) => {
				setTimeout(() => {
					instance?.focus();
					instance?.selection?.setCursorIn(instance.editor, false);
				}, 50);
			},
			keydown: (event) => {
				const sendonenter = localStorage.getItem("radioOptions") === "sentMessage";
				if (event.key === "Enter" && !event.shiftKey) {
				event.preventDefault();
				if(messageBehaviorRef.current == "sendOnEnter" || (props.messageBehavior == undefined && sendonenter)){
					setEmailContent(editor.current?.value);
					console.log("editor.current?.value",editor.current?.value)
					props.saveCommentForTask?.(editor.current?.value);
				} else if(props.taskCommenRef === undefined ? "" : props.taskCommenRef.current == "sendOnEnter"){
					setEmailContent(editor.current?.value);
					console.log("editor.current?.value",editor.current?.value)
					props.saveCommentForTask?.(editor.current?.value);
				}
				// Send the message (content)
				if (content.trim()) {
					setContent("");
					if (editor.current) {
						editor.current.setEditorValue("");
					}
				}
				}
			},
		},
		buttons: [
			'bold',
			'italic',
			'underline',
			'strikethrough',
			'|',
			'font',
			'fontsize',
			'brush',
			'copyformat',
			'|',
			'eraser',
			'|',
			'align',
			'|',
			'ul',
			'ol',
			'hr',
			'|',
			'paragraph',
			'|',
			'table',
			'|',
			'speechRecognize',
			'spellcheck',
			'|',
			'undo',
			'redo',
			'|',
			'print'
		],
		removeButtons: [
			'video',
			'superscript',
			'subscript',
			'file',
			'indent',
			'outdent',
			'formatPainter',
			'link',
			'unlink',
			'source',
			'code',
			'symbol',
			'selectall',
			'cutformat',
			'copy',
			'cut',
			'paste',
			'copyhtml',
			'cuthtml',
			'insertImage',
			'filebrowser',
			'about',
			"breakline",
		],
		buttonsMD: ['bold', 'italic', 'underline', 'strikethrough', 'ul', 'ol', 'font', 'fontsize', 'align', 'dots'], // Medium screens
		buttonsSM: ['bold', 'italic', 'underline', 'strikethrough', 'ul', 'ol', 'font', 'fontsize', 'dots'],          // Small screens
		buttonsXS: ['bold', 'italic', 'underline', 'strikethrough', 'ul', 'ol', 'font', 'fontsize', 'dots']
	}), []);

	// Debounce function for delayed state update
	const debouncedHandleChangeEditor = useCallback(
		debounce((value) => {
			setContent(value); // State updates after delay
		}, 500),
		[]
	);
	const handleSelectUser = (user) => {
		if (!editor.current) return;
		const editorInstance = editor.current.value;
		const mentionText = editorInstance.replace(/@\w*$/, `<a href="">${user.full_name}</a> `);
		setContent(mentionText)
		setShowSuggestions(false);
		setMention("");
	};

	const handleChangeEditor = (e) => {
		 // Immediate textbox update
		// setContent(e);
		if(props?.signature=="NoSignature"){
			setEmailContent(e);
		}
		const cursorText = e;
		const atIndex = cursorText.lastIndexOf("@");
		const hashIndex = cursorText.lastIndexOf("#");

		if (atIndex !== -1) {
			const afterAt = cursorText.substring(atIndex + 1);
			if (afterAt.length >= 0) {
			setMention(afterAt);
				props.setShowMentionList?.(true)
			}
		} else {
				props.setShowMentionList?.(false)
			// setShowSuggestions(false);
		}

		if (hashIndex !== -1 && hashIndex > atIndex) {
			props.setShowTagList?.(true)
		} else {
				props.setShowTagList?.(false)
		}
		};
	

	return (<> <div className='jodit-text-editor-wrapper'>
		<JoditEditor
			ref={editor}
			value={content}
			tabIndex={1}
			onBlur={(value) => {
				setContent(value);
				setEmailContent(value);
			}}
			config={config}
			onChange={(e) => handleChangeEditor(e)}
			className={joditClass ? joditClass : "default-class"}
		/>
	</div>
	{/* {showSuggestions && (
		<ul
			style={{position: "absolute", bottom: "40px",left: 0, background: "#fff", border: "1px solid #ddd",
				borderRadius: "5px", width: "200px", maxHeight: "150px", overflowY: "auto", zIndex: 1000,
				listStyle: "none", margin: 0, padding: "5px",
			}}
		>
			{props.allUsers?.filter((u) =>
				u.full_name.toLowerCase().startsWith(mention.toLowerCase())
			).map((u) => (
				<li
                      key={u.email}
                      onClick={() => handleSelectUser(u)}
					style={{ padding: "5px", cursor: "pointer" }}
				>
				@{u.full_name}
				</li>
			))}
		</ul>
		)} */}
	</>
	)
}

export default JoditTextEditor